import React from 'react';
import EnquiryForm from '../../common/EnquiryForm.js';
import {baseUrl} from '../../utils/utils.js';
import styles from './ProductSlide.module.scss';

const ProductSlide = props => {
  return (
    <div
      className={styles.slide}
      onTouchStart={(e) => props.handleTouchStart(e)}
      onTouchEnd={(e) => props.handleTouchEnd(e)}
    >
      <img 
        src={baseUrl(`img/products/${props.image}`)}
        alt={props.product_code}
        className={styles.image}
      />
      <div className={styles.rightSection}>
        <h2 className={styles.productCode}>
          {props.product_code}
        </h2>
        <p className={styles.productDescription}>
          {props.description}
        </p>
        <EnquiryForm productCode={props.product_code}/>
      </div>
    </div>
  );
};

export default ProductSlide;